import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import {ArrowCircleUp as ArrowCircleUpIcon} from "@mui/icons-material";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

function BackToTop(props: any) {
  const [isVisible, setIsVisible] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleVisibility = () => {
    if (window.pageYOffset > 1000) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {isVisible ? (
        <Button
          id="back-to-top"
          color="primary"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            top: "72px",
            bottom: "auto",
            right: "16px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "fit-content",
            zIndex: 1000,
            backgroundColor: "#000",
            padding: "6px 16px",
            borderRadius: "20px",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#000",
              color: "#fff",
            },
            "@media (max-width: 768px)": {
              top: props.isMobileView ? "30px" : "86px",
              fontSize: "14px",
            },
          }}
          startIcon={<ArrowCircleUpIcon />}
        >
         {t( LOCALIZATION?.Back_to_top)}
        </Button>
      ) : null}
    </>
  );
}

export default BackToTop;
